import React from 'react';
import {
    Grid, Row, Col,
    FormGroup, ControlLabel, FormControl
} from 'react-bootstrap';

import {Card} from 'components/Card/Card.jsx';
import {FormInputs} from 'components/FormInputs/FormInputs.jsx';
import {UserCard} from 'components/UserCard/UserCard.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';
import { ProjectName, ProjectSlogan } from 'variables/DigmaDef';

// import avatar from "assets/img/faces/face-3.jpg";
// const hayaImage = 'https://www.lingolearn.co.il/images/hayav.jpg';

export class UserProfile extends React.PureComponent {
    render() {
        // console.log("userprofile", this.props)
        const {mbouser} = this.props

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={8}>
                            <Card
                                title={"נתוני משתמש: " + mbouser.user_display_name}
                                content={
                                    <form>
                                        <FormInputs
                                            ncols = {["col-md-4" , "col-md-2" , "col-md-4", "col-md-2"]}
                                            proprieties = {[
                                                {
                                                 label : "חברה (לא ניתן לעריכה)",
                                                 type : "text",
                                                 bsClass : "form-control",
                                                 placeholder : "חברה",
                                                 defaultValue : ProjectName + ' - ' + ProjectSlogan, // "יהב - יחד המשפחה בצמיחה",
                                                 disabled : true
                                                },
                                                {
                                                    label : "הרשאות",
                                                    type : "text",
                                                    bsClass : "form-control",
                                                    placeholder : "הרשאות",
                                                    defaultValue : mbouser.user_role[0] 
                                                },
                                                {
                                                 label : "כתובת דואר אלקטרוני",
                                                 type : "email",
                                                 bsClass : "form-control",
                                                 placeholder : mbouser.user_email, // "haya@digma.org.il"
                                                 defaultValue : mbouser.user_email // "haya@digma.org.il"
                                                },
                                                {
                                                    label : "שם משתמש",
                                                    type : "text",
                                                    bsClass : "form-control",
                                                    placeholder : "שם משתמש",
                                                    defaultValue : mbouser.user_display_name 
                                                }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols = {["col-md-6" , "col-md-6"]}
                                            proprieties = {[
                                                {
                                                 label : "שם פרטי",
                                                 type : "text",
                                                 bsClass : "form-control",
                                                 placeholder : "שם פרטי",
                                                 defaultValue : mbouser.user_display_name // "חיה"
                                                },
                                                {
                                                 label : "שם משפחה",
                                                 type : "text",
                                                 bsClass : "form-control",
                                                 placeholder : "שם משפחה",
                                                 defaultValue : mbouser.user_display_name //"אמזלג באהר"
                                                }
                                            ]}
                                        />
                                        {/*
                                        <FormInputs
                                            ncols = {["col-md-12"]}
                                            proprieties = {[
                                                {
                                                    label : "כתובת",
                                                    type : "text",
                                                    bsClass : "form-control",
                                                    placeholder : "כתובת",
                                                    defaultValue : ""
                                                }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols = {["col-md-4","col-md-4","col-md-4"]}
                                            proprieties = {[
                                                {
                                                    label : "ישוב",
                                                    type : "text",
                                                    bsClass : "form-control",
                                                    placeholder : "ישוב",
                                                    defaultValue : "ירוחם"
                                                },
                                                {
                                                    label : "ארץ",
                                                    type : "text",
                                                    bsClass : "form-control",
                                                    placeholder : "ארץ",
                                                    defaultValue : "ישראל"
                                                },
                                                {
                                                    label : "מיקוד",
                                                    type : "number",
                                                    bsClass : "form-control",
                                                    placeholder : ""
                                                }
                                            ]}
                                        />
                                        */}
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup controlId="formControlsTextarea">
                                                    <ControlLabel>אודותי</ControlLabel>
                                                    <FormControl rows="8" componentClass="textarea" bsClass="form-control" 
                                                        placeholder="כאן ניתן להוסיף תיאור" 
                                                        defaultValue="דיגמה = הדלתא של הסיגמא; הינה הערך המוסף של השינוי בָּשָׁלֵם.  דיגמה הערכה ישומית מנוהלת על ידי חיה אמזלג – באהר, בעלת תאר שני בסוציולוגיה ובפסיכולוגיה חברתית ומנחת קבוצות מוסמכת.
                                                         המכון מעסיק אנשי מקצוע בתחומים של התנהגות ארגונית, חברה, עבודה סוציאלית, קהילה וחינוך. חיה ניהלה במשותף את מכון מתווה להערכה ישומית. לחיה מעל 25 שנות נסיון בתחומי התנהגות ארגונית, חברה, עבודה סוציאלית, קהילה וחינוך.
                                                          .מכון דיגמה  ממשיך את הפעילות של מכון מתווה, אשר פעל בישראל במשך 17 שנים עד שנת 2009 בתחומי הערכה ישומית
                                                        דיגמה מציעה שרותי הערכה מגוונים לארגונים, תכניות ופרוייקטים בתחומי החברה, החינוך והשירותים (המוסדיים, הפרטיים והוולנטריים) בישראל.
                                                        אנו פועלים עם לקוחותינו למציאת השינויים שיביאו לערך מוסף גבוה יותר לארגון."
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {/*<Button
                                            bsStyle="info"
                                            pullRight
                                            fill
                                            type="submit"
                                        >
                                            עדכן פרטים
                                        </Button>*/}
                                        <div className="clearfix"></div>
                                    </form>
                                }
                            />
                        </Col>
                        <Col md={4}>
                            <UserCard
                                //bgImage="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
                                //bgImage="https://digma.org.il/wp-content/uploads/2012/03/Digma-Header-BG.png"
                                bgImage="Digma-Header-BG.png"
                                // avatar={hayaImage}
                                name= {mbouser.user_display_name}  //"חיה באהר"
                                userName= {mbouser.user_display_name}
                                description={
                                    <span>
                                    <strong>ניב</strong> \\ רחל<br />
                                    יוֹדַעַת אֲנִי אִמְרֵי נוֹי לְמַכְבִּיר,<br />
                                    מְלִיצוֹת בְּלִי סוֹף,<br />
                                    הַהוֹלְכוֹת הָלוֹךְ וְטָפוֹף,<br />
                                    מַבָּטָן יָהִיר.<br />
                                    <br />
                                    אַךְ לִבִּי לַנִּיב הַתָּמִים כְּתִינוֹק<br />
                                    וְעָנָו כֶּעָפָר.<br />
                                    יָדַעְתִּי מִלִּים אֵין מִסְפָּר –<br />
                                    עַל כֵּן אֶשְׁתֹּק.<br />
                                    <br />
                                    הֲתִקְלֹט אָזְנְךָ אַף מִתּוֹךְ שְׁתִיקָה<br />
                                    אֶת נִיבִי הַשַּׂח?<br />
                                    הֲתִנְצְרֵהוּ כְּרֵעַ, כְּאָח,<br />
                                    כְּאֵם בְּחֵיקָהּ?<br />
                                    </span>
                                }
                                socials={
                                    <div>
                                        <Button simple><i className="fa fa-facebook-square"></i></Button>
                                        <Button simple><i className="fa fa-twitter"></i></Button>
                                        <Button simple><i className="fa fa-google-plus-square"></i></Button>
                                    </div>
                                }
                            />
                        </Col>

                    </Row>
                </Grid>
            </div>
        );
    }
}

//export default UserProfile;
